export default __webpack_public_path__ + "static/media/sample.78a57991.pdf";